import basketApiClient from '../basket/apiClient';
import currenciesService from '../currenciesService';
import events from '../events';
import formatPrice from '../utils/formatPrice';
const initState = {
    error: [],
    success: null,
    status: 0,
};
export function cartModal() {
    return {
        ...initState,
        loading: false,
        products: [],
        subtotal: 0,
        subtotalText: '',
        foreignSubtotalText: '',
        open: false,
        init() {
            events.onBasketUpdated.subscribe(data => {
                if (this.open)
                    return;
                const basket = data.basket;
                this.subtotalText = basket.subtotalText;
                this.subtotal = basket.subtotal;
                const newBasketItems = [];
                data.products.forEach(item => {
                    let currentBasketItem;
                    if (item.variants != undefined && item.variants.length > 0) {
                        item.variants.forEach(variant => {
                            currentBasketItem = basket.products.find(v => v.sku === item.sku && v.variantSku === variant);
                            currentBasketItem && newBasketItems.push(currentBasketItem);
                        });
                    }
                    else {
                        currentBasketItem = basket.products.find(p => p.sku === item.sku);
                        currentBasketItem && newBasketItems.push(currentBasketItem);
                    }
                });
                this.products = newBasketItems;
                window.scrollTo(0, 0);
                this.applyCurrencyExchange(currenciesService.getRate());
                this.open = true;
            });
        },
        closeCartModal() {
            this.open = false;
        },
        onQuantityUpdate(orderLineId, newQuantity) {
            this.loading = true;
            basketApiClient.updateItem(orderLineId, newQuantity)
                .then(basket => {
                this.subtotalText = basket.subtotalText;
                this.subtotal = basket.subtotal;
                this.applyCurrencyExchange(currenciesService.getRate());
                events.onBasketUpdated.trigger({ basket, products: [] });
            })
                .catch(err => this.error.push(err))
                .finally(() => {
                this.loading = false;
            });
        },
        applyCurrencyExchange(currency) {
            if (!currency)
                return;
            this.products.forEach(product => {
                if (currency && currency.rate !== 1) {
                    const foreignPrice = product.price * currency.rate;
                    const foreignSubtotalPrice = this.subtotal * currency.rate;
                    product.foreignPriceText = `~ ${formatPrice(foreignPrice, currency.currency)}`;
                    this.foreignSubtotalText = `~ ${formatPrice(foreignSubtotalPrice, currency.currency)}`;
                }
                else {
                    product.foreignPriceText = '';
                    this.foreignSubtotalText = '';
                }
            });
        },
    };
}
;
